import {
  Confirm as confirm,
  Alert as rawAlert,
  Toast as toast,
  Notify as notify,
  Loading as loading
} from "vue-ydui/dist/lib.rem/dialog";

function normalizeAlertOptions(options, callback) {
  const config = typeof options === "string" ? { mes: options } : { ...options };
  if (typeof callback === "function" && !config.callback) {
    config.callback = callback;
  }
  return config;
}

function alert(options = {}, callback) {
  const config = normalizeAlertOptions(options, callback);
  const userCallback = config.callback;

  if (config.title) {
    return confirm({
      title: config.title,
      mes: config.mes,
      opts: [
        {
          txt: config.btnText || "确定",
          color: true,
          callback: () => {
            if (typeof userCallback === "function") {
              userCallback();
            }
          }
        }
      ]
    });
  }

  return rawAlert(config);
}

const dialog = {
  confirm,
  alert,
  toast,
  notify,
  loading
};

const icons = { error: "操作失败", success: "操作成功" };
Object.keys(icons).reduce((dialog, key) => {
  dialog[key] = (mes, obj = {}) => {
    return new Promise(function(resolve) {
      toast({
        mes: mes || icons[key],
        timeout: 2000,
        icon: key,
        callback: () => {
          resolve();
        },
        ...obj
      });
    });
  };
  return dialog;
}, dialog);

dialog.message = (mes = "操作失败", obj = {}) => {
  return new Promise(function(resolve) {
    toast({
      mes,
      timeout: 2000,
      callback: () => {
        resolve();
      },
      ...obj
    });
  });
};

dialog.validateError = (...args) => {
  validatorDefaultCatch(...args);
};

export function validatorDefaultCatch(err, type = "message") {
  return dialog[type](err.errors[0].message);
}

export default dialog;
